import React, { useReducer, useRef, useCallback, useEffect } from 'react';
import { Search, Grid } from 'semantic-ui-react';
import { SearchState, initialState, actions } from './util';
import _ from 'lodash';

const searchReducer = (state: SearchState, action) => {
    switch (action.type) {
        case actions.CLEAN_QUERY:
            return initialState;
        case actions.START_SEARCH:
            return { ...state, loading: true, value: action.query };
        case actions.FINISH_SEARCH:
            return { ...state, loading: false, results: action.results };
        case actions.UPDATE_SELECTION:
            return { ...state, value: action.selection };
        default:
            throw new Error();
    }
};

const SearchPosts = ({ posts, setResults, center = false }) => {
    const [state, dispatch] = useReducer(searchReducer, initialState);
    const { loading, results, value } = state;
    const timeoutRef: any = useRef();

    const handleSearchChange = useCallback((e, data) => {
        clearTimeout(timeoutRef.current);
        dispatch({ type: actions.START_SEARCH, query: data.value });

        timeoutRef.current = setTimeout(() => {
            if (data.value.length === 0) {
                dispatch({ type: actions.CLEAN_QUERY });
                setResults([]);
                return;
            }

            const re = new RegExp(_.escapeRegExp(data.value), 'i');
            const isMatch = (result) => re.test(result.title);

            dispatch({
                type: actions.FINISH_SEARCH,
                results: _.filter(posts, isMatch),
            });

            setResults(_.filter(posts, isMatch));
        }, 300);
    }, []);

    useEffect(() => {
        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);

    const onResultSelect = (e, data) => {
        dispatch({
            type: actions.UPDATE_SELECTION,
            selection: data.result.title,
        });
        setResults([data.result]);
    };

    const className = center ? 'center-self' : '';

    return (
        <Grid>
            <Grid.Column width={6} className={className}>
                <Search loading={loading} onResultSelect={onResultSelect} onSearchChange={handleSearchChange} results={results} value={value} />
            </Grid.Column>
        </Grid>
    );
};

export default SearchPosts;
